import { ButtonGroup, ToggleButton } from "react-bootstrap"
import styles from "../../forms.module.scss"
import { AssignOption } from "shared/types/teacherTypes"

interface Props {
    onClassChosen: any
    onStudentsChosen: any
    assignOption: AssignOption
}

const AssignOptionToggle = ({ onClassChosen, onStudentsChosen, assignOption } : Props) => {
  return (
    <ButtonGroup className="d-flex justify-content-center">
        <ToggleButton
            value="class"
            type="radio"
            className={`fw-bold ${assignOption === "class" ? styles.termBgSelect : styles.termBgUnselect} border-0`}
            onClick={onClassChosen}
        >Class</ToggleButton>

        <ToggleButton
            value="students"
            type="radio"
            className={`fw-bold ${assignOption === "students" ? styles.termBgSelect : styles.termBgUnselect} border-0`}
            onClick={onStudentsChosen}
        >Students</ToggleButton>
    </ButtonGroup>
  )
}

export default AssignOptionToggle
